import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "closure-calendar-container" };
const _hoisted_2 = { class: "row mb-4 align-items-end" };
const _hoisted_3 = {
    key: 0,
    class: "col-md-4"
};
const _hoisted_4 = { class: "form-label fw-bold" };
const _hoisted_5 = {
    key: 1,
    class: "col-md-4"
};
const _hoisted_6 = { class: "form-label fw-bold" };
const _hoisted_7 = { class: "col-md-4 text-end ms-auto" };
const _hoisted_8 = { class: "calendar-wrapper shadow-sm rounded bg-white p-3" };
const _hoisted_9 = {
    class: "modal fade",
    id: "closureModal",
    tabindex: "-1",
    "aria-hidden": "true"
};
const _hoisted_10 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_11 = { class: "modal-content border-0 shadow-lg" };
const _hoisted_12 = { class: "modal-header bg-primary text-white" };
const _hoisted_13 = { class: "modal-title" };
const _hoisted_14 = { class: "modal-body p-4" };
const _hoisted_15 = {
    key: 0,
    class: "mb-3"
};
const _hoisted_16 = { class: "d-flex gap-3" };
const _hoisted_17 = { class: "form-check" };
const _hoisted_18 = {
    key: 0,
    class: "form-check"
};
const _hoisted_19 = { class: "mb-3" };
const _hoisted_20 = { class: "form-label fw-medium" };
const _hoisted_21 = ["placeholder"];
const _hoisted_22 = { class: "row mb-3" };
const _hoisted_23 = { class: "col-md-6" };
const _hoisted_24 = { class: "form-label fw-medium" };
const _hoisted_25 = { class: "col-md-6" };
const _hoisted_26 = { class: "form-label fw-medium" };
const _hoisted_27 = { class: "mb-3" };
const _hoisted_28 = { class: "form-check form-switch" };
const _hoisted_29 = {
    class: "form-check-label fw-medium",
    for: "recurringSwitch"
};
const _hoisted_30 = { class: "text-muted d-block mt-1" };
const _hoisted_31 = { class: "d-flex justify-content-between mt-4" };
const _hoisted_32 = { class: "ms-auto d-flex gap-2" };
const _hoisted_33 = ["disabled"];
const _hoisted_34 = {
    key: 0,
    class: "spinner-border spinner-border-sm me-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_FullCalendar = _resolveComponent("FullCalendar");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('closures.franchiseSelection')), 1),
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedFranchiseId,
                        "onUpdate:modelValue": [
                            _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedFranchiseId) = $event)),
                            _ctx.onFranchiseChange
                        ],
                        options: _ctx.franchiseOptions,
                        label: "name",
                        reduce: f => f.id,
                        placeholder: "Choisir une franchise"
                    }, null, 8, ["modelValue", "options", "reduce", "onUpdate:modelValue"])
                ]))
                : _createCommentVNode("", true),
            (_ctx.isAdmin || _ctx.isFranchise)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('closures.restaurantSelection')), 1),
                    _createVNode(_component_v_select, {
                        modelValue: _ctx.selectedRestaurantId,
                        "onUpdate:modelValue": [
                            _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedRestaurantId) = $event)),
                            _ctx.fetchClosures
                        ],
                        options: _ctx.restaurantOptions,
                        label: "name",
                        reduce: r => r.id,
                        placeholder: _ctx.$t('lists.selectRestaurant')
                    }, {
                        option: _withCtx((option) => [
                            _createTextVNode(_toDisplayString(option.name), 1)
                        ]),
                        _: 1
                    }, 8, ["modelValue", "options", "reduce", "onUpdate:modelValue", "placeholder"])
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.openAddModal && _ctx.openAddModal(...args)))
                }, [
                    _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fas fa-plus me-2" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('closures.addClosure')), 1)
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FullCalendar, {
                ref: "fullCalendar",
                options: _ctx.calendarOptions
            }, null, 8, ["options"])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.isEditing ? _ctx.$t('closures.editClosure') : _ctx.$t('closures.addClosure')), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close btn-close-white",
                            onClick: _cache[3] || (_cache[3] =
                                //@ts-ignore
                                (...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
                            "aria-label": "Close"
                        })
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("form", {
                            onSubmit: _cache[12] || (_cache[12] = _withModifiers(
                            //@ts-ignore
                            (...args) => (_ctx.saveClosure && _ctx.saveClosure(...args)), ["prevent"]))
                        }, [
                            ((_ctx.isAdmin || _ctx.isFranchise) && !_ctx.isEditing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label fw-medium" }, "Type de fermeture", -1)),
                                    _createElementVNode("div", _hoisted_16, [
                                        _createElementVNode("div", _hoisted_17, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "radio",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formType) = $event)),
                                                value: "restaurant",
                                                id: "typeResto"
                                            }, null, 512), [
                                                [_vModelRadio, _ctx.formType]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "typeResto"
                                            }, "Restaurant", -1))
                                        ]),
                                        (_ctx.isAdmin || _ctx.isFranchise)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                _withDirectives(_createElementVNode("input", {
                                                    class: "form-check-input",
                                                    type: "radio",
                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.formType) = $event)),
                                                    value: "franchise",
                                                    id: "typeFranchise"
                                                }, null, 512), [
                                                    [_vModelRadio, _ctx.formType]
                                                ]),
                                                _cache[15] || (_cache[15] = _createElementVNode("label", {
                                                    class: "form-check-label",
                                                    for: "typeFranchise"
                                                }, "Franchise (Tous ses restos)", -1))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_19, [
                                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('closures.reason')), 1),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.form.reason) = $event)),
                                    class: "form-control",
                                    placeholder: _ctx.$t('closures.noReason')
                                }, null, 8, _hoisted_21), [
                                    [_vModelText, _ctx.form.reason]
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('closures.startDate')), 1),
                                    _createVNode(_component_flat_pickr, {
                                        modelValue: _ctx.form.startDate,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.form.startDate) = $event)),
                                        config: _ctx.dateConfig,
                                        class: "form-control bg-white"
                                    }, null, 8, ["modelValue", "config"])
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                    _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('closures.endDate')), 1),
                                    _createVNode(_component_flat_pickr, {
                                        modelValue: _ctx.form.endDate,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.form.endDate) = $event)),
                                        config: _ctx.dateConfig,
                                        class: "form-control bg-white"
                                    }, null, 8, ["modelValue", "config"])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.form.isRecurring) = $event)),
                                        id: "recurringSwitch"
                                    }, null, 512), [
                                        [_vModelCheckbox, _ctx.form.isRecurring]
                                    ]),
                                    _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('closures.isRecurring')), 1)
                                ]),
                                _createElementVNode("small", _hoisted_30, _toDisplayString(_ctx.$t('closures.recurringHelp')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                                (_ctx.isEditing)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "btn btn-outline-danger",
                                        onClick: _cache[10] || (_cache[10] =
                                            //@ts-ignore
                                            (...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
                                    }, [
                                        _cache[17] || (_cache[17] = _createElementVNode("i", { class: "fas fa-trash me-2" }, null, -1)),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.delete')), 1)
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_32, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn-light",
                                        onClick: _cache[11] || (_cache[11] =
                                            //@ts-ignore
                                            (...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
                                    }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: "btn btn-primary px-4",
                                        disabled: _ctx.isSaving
                                    }, [
                                        (_ctx.isSaving)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                                            : _createCommentVNode("", true),
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('common.save')), 1)
                                    ], 8, _hoisted_33)
                                ])
                            ])
                        ], 32)
                    ])
                ])
            ])
        ])
    ]));
}
